module.exports = __webpack_public_path__ + "static/media/PORMPURAAW ABORIGINAL SHIRE.3b347237.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/council_areas/PORMPURAAW ABORIGINAL SHIRE.svg
// module id = 574
// module chunks = 0